<template>
  <div>
    <Loading :isLoading="this.isLoading"/>
    <Modal v-if="showModalListDocuments" :widthContainer="'50%'" :heightContainer="'50%'">
      <h3 slot="header" style="font-weight:500;font-size:24px;font-family:Roboto;color:#179099;">Lista de Documentos Cargados</h3>
      <div slot="body">
        <div class="">
          <p style="font-weight:500;font-size:20px;font-family:Roboto;margin-bottom:30px;">De Click sobre el elemento de un Documento para visualizarlo.</p>
          <div class="grid grid-cols-1 gap-4" style="border: 1px solid #179099;padding:10px;margin-top:10px;"
           v-for="(document, index) in documents_list" :key="index">
           <a v-on:click="viewDocument(document.url)" style="cursor:pointer;text-decoration:none">
             <div style="">
                <p style="width:70%;text-align:left;font-family:Roboto;
                  font-size:18px;font-weight:500;">{{documentsAbbreviationEnum[document.abbreviation]}}:</p>
                <p style="width:70%;word-wrap: break-word;text-align:left;font-family:Roboto;
                  font-size:18px;font-weight:300;">
                  {{`${document.document_name}.${document.extension}` }}
                </p>
              </div>
           </a>
          </div>
        </div>
      </div>
      <div slot="footer" style="padding:0px !important">
        <input type="button" value="Cerrar" class="closeModalButton" v-on:click="showModalListDocuments = false">
      </div>
    </Modal>
    <div style="margin-top:30px;">
      <ReedirectButton />
    </div>
    <FilterButtons ref="filterButtonsComponent" :list_to_filter="requests" 
      v-on:filter-list-by-status="getRequestsFiltered($event)" />
    <div style="clear: both;"></div>
    <div style="margin-top:30px;" id="pendingRequest">
      <div>
        <p style="text-align:left;font-size:24px;color: #6B6969;font-weight:bold;font-family:Roboto;">{{descriptionText}}</p>
      </div>
      <div class="flex" style="margin-top:30px;">
        <SearchByRfc ref="searchByRfcComponent" :list_to_filter="requests"
          v-on:filter-info-by-rfc="getListFilteredByRfc($event)" />
      </div>
      <div class="flex" style="margin-top:30px;" v-if="requestsFiltered.length <= 0">
        <p class="description">No se encontraron registros</p>
      </div>
      <table class="table tableRenounceRequests" id="table-id" style="margin-top:20px;">
        <thead>
          <tr>
            <th>
              #
            </th>
            <th v-on:click="sortTable('rfc')">
              <div class="grid grid-cols-2">
                <div>
                  RFC
                </div>
                <div>
                  <div class="arrow" v-if="'rfc' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('name')">
              <div class="grid grid-cols-2">
                <div>
                  NOMBRE
                </div>
                <div>
                  <div class="arrow" v-if="'name' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('email')">
              <div class="grid grid-cols-2">
                <div>
                  EMAIL
                </div>
                <div>
                  <div class="arrow" v-if="'email' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('email')">
              <div class="grid grid-cols-2">
                <div>
                  CELULAR
                </div>
                <div>
                  <div class="arrow" v-if="'email' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('budget_keys')">
              <div class="grid grid-cols-2">
                <div>
                  TIPO DE RENUNCIA
                </div>
                <div>
                  <div class="arrow" v-if="'budget_keys' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('beneficiary_name')">
              <div class="grid grid-cols-2">
                <div>
                  BENEFICIARIO
                </div>
                <div>
                  <div class="arrow" v-if="'beneficiary_name' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('created_at')">
              <div class="grid grid-cols-2">
                <div>
                  FECHA DE REGISTRO
                </div>
                <div>
                  <div class="arrow" v-if="'created_at' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-if="statusFilter != 'aceptado'"></th>
            <th v-if="statusFilter == 'pendiente'"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in requestsFiltered" :key="item.id">
            <td>{{index+1}}</td>
            <td>{{item.rfc | capitalize}}</td>
            <td>{{item.name | camelize}} {{item.paternal_name | camelize}} {{item.maternal_name | camelize}}</td>
            <td>{{item.email}}</td>
            <td>{{item.cellphone | VMask('### ###-####')}}</td>
            <td>{{item.withdraw_type | capitalize}}</td>
            <td>{{item.beneficiary_name | camelize}} {{item.beneficiary_middle_name | camelize}} {{item.beneficiary_paternal_name | camelize}} {{item.beneficiary_maternal_name | camelize}}</td>
            <td>{{item.created_at | moment}}</td>
            <td style="padding-left:0px;"><input type="button" class="viewHistory" value="Documentos Cargados" id="button_document_attached" v-on:click="getDocumentsBySavingId(item.id)" /></td>
            <!--<td v-if="statusFilter != 'aceptado'" style="padding-left:0px;"><input type="button" class="acceptRequest" value="Aceptar" id="button_accept" v-on:click="acceptRequest(item)" /></td>-->
            <td v-if="statusFilter != 'aceptado'" style="padding-left:0px;"><input type="button" class="acceptRequest" value="Capturar" id="button_capture" v-on:click="redirect('http://172.16.201.7/agregarrenunciasayp.asp?rfcseleccionado='+item.rfc)" /></td>
            <td v-if="statusFilter == 'pendiente'" style="padding-left:0px;"><input type="button" class="rejectRequest" value="Rechazar" id="button_reject" v-on:click="rejectRequest(item)" /></td>
          </tr>
        </tbody>
      </table>
      <div v-show="requestsFiltered.length > elementsPerPage" class='pagination-container' style="text-align:center;">
        <nav>
          <ul class="pagination pagination-requests">
            <li data-page="prev" style="cursor: pointer;">
              <span>Anterior<span class="sr-only">(current)</span></span>
            </li>
            <li data-page="next" id="prev" style="cursor: pointer;">
              <span>Siguiente<span class="sr-only">(current)</span></span>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="form-group" style="visibility:hidden"> 	<!--		Show Numbers Of Rows 		-->
      <select class ="form-control" name="state" id="maxRows">
        <option value="5000">Show ALL Rows</option>
        <option value="5">5</option>
      </select>
    </div>
  </div>
</template>

<script>
import User from '@/classes/User'
import Saving from '@/classes/Saving'
import Document from '@/classes/Document'

import { getPagination, filterByStatus } from '@/helpers/tablePagination'

import Swal from 'sweetalert2'
import FilterButtons from '@/components/FilterButtons/FilterButtons.vue'
import SearchByRfc from '@/components/Search/SearchByRfc.vue'
import Loading from '@/components/Loading/Loading.vue'
import ReedirectButton from '@/components/Forms/ReedirectButton.vue'

import { descriptionRequestText, documentsAbbreviation } from '@/helpers/enums'
import {sendMailNotificationClient, bodyEmailNotificationClient} from '@/helpers/email'
import('@/assets/css/stylesheet.css')
import Modal from '@/components/Modal/Modal.vue'


export default {
  data() {
    return {
      isLoading: false,
      token_auth: "",
      rfc: "",
      descriptionText: "Solicitudes Pendientes",
      requests: [],
      requestsFiltered: [],
      userObjectClass: null,
      savingObjectClass: null,
      documentObjectClass: null,
      documents_list: [],
      showModalListDocuments: false,
      sortColumn: "",
      ascending: false,
      statusFilter: "pendiente",
      elementsPerPage: 10,
      documentsAbbreviationEnum: documentsAbbreviation,
      userFas: process.env.VUE_APP_USER_FAS,
      passwordFas: process.env.VUE_APP_PASSWORD_FAS,
    }
  },
  name: 'RenounceSavingRequestedComponent',
  components: {
    FilterButtons,
    Loading,
    SearchByRfc,
    ReedirectButton,
    Modal
  },
  mounted() {
    this.userObjectClass = new User();
    this.savingObjectClass = new Saving();
    this.documentObjectClass = new Document();

    this.login();
  },
  methods: {
    getRequestsFiltered(event) {
      this.statusFilter = event.status;
      this.changeDescriptionText(event.status);
      this.setRenounceSavingRequestFiltered(event.data).then(response => {
        getPagination("#table-id", ".pagination-requests", "#prev", "#maxRows", this.elementsPerPage, this.requestsFiltered.length);
      });
    },
    async setRenounceSavingRequestFiltered(requestFiltered) {
      this.requestsFiltered = requestFiltered;
    },
    login() {
      this.isLoading = true;
      this.userObjectClass.login(this.userFas, this.passwordFas).then(response => {
        this.token_auth = response.data.token_auth;
        this.getRenounceSavingRequests().then(response => {
          this.$refs.filterButtonsComponent.filterByStatus("pendiente");
        });

        this.isLoading = false;
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      })
    },
    async getRenounceSavingRequests() {
      return await this.savingObjectClass.getRenounceRequests(this.token_auth).then(response => {
        this.requests = response.data.response.data;
        console.log(this.requests);
      }).catch(error => {
        console.error(error);
      });
    },
    sortTable(col) {
      if (this.sortColumn === col) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortColumn = col;
      }

      var ascending = this.ascending;

      this.requestsFiltered.sort(function(a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0;
      })
    },
    acceptRequest(request) {
      Swal.fire({
        title: "Aviso",
        customClass: {
          container: 'my-swal'
        },
        text: "¿Desea aceptar la solicitud?",
        html: `<p style="font-size:18px;">¿Desea aceptar la solicitud de <span style="font-weight:bold;">
          ${this.camelize(request.name)} ${this.camelize(request.paternal_name)} ${this.camelize(request.maternal_name)}</span>?</p>`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.savingObjectClass.acceptRenounceRequest(this.token_auth, request.id).then(response => {
            let bodyEmail = bodyEmailNotificationClient("Confirmación de Solicitud",`Su Solicitud de Renuncia al Ahorro ha sido aceptada.`, 'http://200.92.206.58:90/renounce-saving/renounce-saving-request');

            sendMailNotificationClient(request.email, "Notificación Solicitud Renuncia al Ahorro", bodyEmail, "").then(response =>{
              this.isLoading = false;
              this.getRenounceSavingRequests().then(response => {
                this.$refs.filterButtonsComponent.filterByStatus(this.statusFilter);
              });
              Swal.fire({
                text: "",
                html: `<p style="font-size:18px;font-weight:bold;">Solicitud de Renuncia al Ahorro aceptada correctamente</p>`,
                confirmButtonText: "Continuar",
                allowOutsideClick: false,
                icon: "success",
              })
            }).catch(error => {
              this.isLoading = false;
              Swal.fire({
                title: "Aviso",
                text: error,
                icon: "warning",
              })
            });
          }).catch(error => {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: error,
              icon: "error",
            })
          })
        }
      });
    },
    rejectRequest(request) {
      Swal.fire({
        title: "Aviso",
        customClass: {
          container: 'my-swal'
        },
        text: "¿Desea rechazar la solicitud?",
        html: `<p style="font-size:18px;">¿Desea rechazar la solicitud de <span style="font-weight:bold;">
          ${this.camelize(request.name)} ${this.camelize(request.paternal_name)} ${this.camelize(request.maternal_name)}</span>?</p>`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if (result.value) {
          this.isLoading = true;

          this.savingObjectClass.rejectRenounceRequest(this.token_auth, request.id).then(response => {
            let bodyEmail = bodyEmailNotificationClient("Confirmación de Solicitud",`Su Solicitud de Renuncia al Ahorro ha sido rechazada.`, 'http://200.92.206.58:90/renounce-saving/renounce-saving-request');

            sendMailNotificationClient(request.email, "Notificación Solicitud Renuncia al Ahorro", bodyEmail, "").then(response =>{
              this.isLoading = false;
              this.getRenounceSavingRequests().then(response => {
                this.$refs.filterButtonsComponent.filterByStatus(this.statusFilter);
              });
              Swal.fire({
                text: "Solicitud de Actualización de Beneficiarios guardada correctamente",
                html: `<p style="font-size:18px;font-weight:bold;">Solicitud de Renuncia al Ahorro rechazada correctamente</p>`,
                confirmButtonText: "Continuar",
                allowOutsideClick: false,
                icon: "success",
              })
            }).catch(error => {
              this.isLoading = false;
              Swal.fire({
                title: "Aviso",
                text: error,
                icon: "warning",
              })
            });
          }).catch(error => {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: error,
              icon: "error",
            })
          });
        }
      })
    },
    openLinkPdf(pdf) {
      this.isLoading = true;
      var a = document.createElement('a');
      a.title = "Carta de no adeudo";
      a.target = "_blank";
      a.href = pdf;
      document.body.appendChild(a);
      a.click();
      this.isLoading = false;
    },
    camelize(value) {
      if (value != "" && value != undefined) {
        let response = "";
        value = value.toLowerCase().replace(/(?:(^.)|([-_\s]+.))/g, function(match) {
          return match.charAt(match.length-1).toUpperCase();
        });
        response = value.charAt(0).toUpperCase() + value.substring(1);
        return response.replace(/([A-Z])/g, ' $1').trim(); 
      }

      return "";
    },
    getListFilteredByRfc(event) {
      console.log("filter by rfc: ", event);
      let requestFilteredByStatus = filterByStatus(event, 'status', this.statusFilter);
      this.setRenounceSavingRequestFiltered(requestFilteredByStatus).then(response => {
        getPagination("#table-id", ".pagination-requests", "#prev", "#maxRows", this.elementsPerPage, this.requestsFiltered.length);
      });
    },
    changeDescriptionText(buttonSelected) {
      this.descriptionText = descriptionRequestText[buttonSelected];
    },
    redirect(url){
      window.location = url
    },
    async getDocumentsBySavingId(requestId) {
      try {
        this.isLoading = true;
        let response = await this.documentObjectClass.getSavingDocumentsAttached(this.token_auth, requestId);
        this.isLoading = false;
        this.documents_list = response.data.response.documents_links;
        this.documents_list = this.documents_list[0]
        this.showModalListDocuments = true;
        console.log("documents:", this.documents_list);
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "warning",
        })
      }
    },
    viewDocument(url) {
      window.open(url,'_blank');
    }
  }
}
</script>